<template>
    <v-row>
        <input ref="fileInput" class="d-none" type="file" @change="onFileChange" :accept="mimeTypes" />
        <span v-if="label" class="label">{{ label }}</span>
        <v-col cols="12" class="pt-0">
            <v-sheet v-if="!previewImg" v-ripple class="container-img" :height="height" @click.stop="pickFile">
                <div @click.stop="pickFile" class="upload-inner">
                    <v-icon size="30" color="accent">mdi-tray-arrow-up</v-icon>
                    <span class="upload-text">{{ $t('common.upload_image') }}</span>
                </div>
            </v-sheet>
            <v-sheet v-else class="container-img with-img" :height="height"
                :style="`background-image: url('${previewImg}')`">
                <v-btn @click.stop="onDeleteFile" color="error" icon class="button-img">
                    <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
            </v-sheet>
        </v-col>
    </v-row>
</template>

<script>
import { storageRef } from '@/utils/Firebase'
import { VInput } from "vuetify/lib/components";

export default {
    name: "KimsaUploadFile",
    extends: VInput,
    props: {
        relativePath: {
            type: String,
            default: 'files'
        },
        mimeTypes: {
            type: String,
            default: '*'
        },
        limitSize: {
            type: [String, Number],
            default: null,
        },
        previewImg: {
            type: String,
            default: null,
        },
        label: {
            type: String,
            default: null,
        },
        rules: {
            type: Array,
            default: () => [],
        },
        details: {
            type: Boolean,
            default: false,
        },
        height: {
            type: [Number, String],
            default: 270,
        }
    },
    data() {
        return {
            file: null,
            megabyte: 1048576,
        }
    },
    methods: {
        reset() {
            const vm = this
            vm.file = null
            if (vm.$refs.fileInput) vm.$refs.fileInput.value = ''
        },
        pickFile() {
            const vm = this
            if (vm.previewImg) return;
            if (vm.$refs.fileInput) vm.$refs.fileInput.click()
        },
        onFileChange(evt) {
            const vm = this
            const file = evt.target.files[0]
            if (!file) return;

            if (vm.limitSize && file.size > (vm.limitSize * vm.megabyte))
                return vm.toast(vm.$t('common.limit_file_size', { size: Math.ceil(file.size / vm.megabyte), max: vm.limitSize }), 'error')

            vm.file = file
            let imgURL = URL.createObjectURL(file);
            vm.$emit('change', { img: imgURL, name: file.name })
        },
        onDeleteFile() {
            const vm = this
            vm.reset()
            vm.$emit('change', null)
            vm.$emit('delete')
        },
        async upload() {
            const vm = this
            const file = vm.file
            if (!file) return console.log('no file selected')
            const savePath = `/${vm.currentUser.uid}/${vm.relativePath}/${vm.$moment().unix()}-${file.name}`
            let uploadTask = await storageRef.child(savePath).put(file)
            return {
                tempUrl: await uploadTask.ref.getDownloadURL(),
                savePath: savePath,
                name: file.name,
            }
        },
    }
}
</script>

<style scoped>
.label {
    display: block;
    width: 100%;
    padding: 12px 12px 0;
    margin-bottom: 6px;
    font-size: var(--fs-label);
    font-weight: 500;
    color: var(--v-txtSecondary-base);
}

.container-img {
    background-color: transparent !important;
    border: 1.5px dashed var(--v-outline2-base);
    border-radius: 10px;
    text-align: center;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: border-color .15s, background .15s;
}

.container-img:not(.with-img):hover {
    border-color: var(--v-accent-base);
    background: rgba(51, 153, 153, .05) !important;
}

.upload-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
}

.upload-text {
    font-size: 13px;
    font-weight: 600;
    color: var(--v-txtSecondary-base);
}

.with-img {
    position: relative !important;
    background-color: var(--v-surface2-base) !important;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    border: 1px solid var(--v-outline-base);
    border-radius: 10px;
    cursor: default;
}

.button-img {
    position: absolute;
    top: 6px;
    right: 6px;
}
</style>